import { useContext } from 'react';

import { RNAction } from './constants';
import { reactNativeWindow } from '../../utils/get-native-window';
import { RNQueryContext } from '../../contexts/rn-query';

export const useShare = () => {
  const { send } = useContext(RNQueryContext);
  if (reactNativeWindow.ReactNativeWebView) {
    return (data: { title: string; url: string; message?: string }) =>
      send(RNAction.share, { payload: data });
  } else {
    return null;
  }
};
